import attachmentService from "@/services/mrfiktiv/services/attachmentService";
import {
  MrfiktivAttachmentRequestViewModelGen,
  MrfiktivCreateAttachmentRequestDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "../../store/VuexPlugin";

@Module({
  dynamic: true,
  namespaced: true,
  name: "attachment-request",
  store
})
class AttachmentRequestStore extends VuexModule {
  protected _attachmentRequest: MrfiktivAttachmentRequestViewModelGen | null = null;
  get attachmentRequest() {
    return this._attachmentRequest;
  }

  @Mutation
  protected _mutateAttachmentRequest(attachmentRequest: MrfiktivAttachmentRequestViewModelGen) {
    this._attachmentRequest = attachmentRequest;
  }

  @Action
  async create({ partnerId, data }: { partnerId: string; data: MrfiktivCreateAttachmentRequestDtoGen }) {
    const created = await attachmentService.create(partnerId, data);

    this.context.commit("_mutateAttachmentRequest", created);

    return created;
  }

  @Action
  async get({ partnerId, attachmentId }: { partnerId: string; attachmentId: string }) {
    const attachmentRequest = await attachmentService.getRequest(partnerId, attachmentId);

    this.context.commit("_mutateAttachmentRequest", attachmentRequest);

    return attachmentRequest;
  }
}

export const AttachmentRequestModule = getModule(AttachmentRequestStore);
